import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StockReviewService {

  private baseUrl = `${environment.Server_URL}/stock`;

  constructor(private http: HttpClient) { }

  /**
   * ⭐ Add / Update star rating
   */
  addStar(data: {
    stock_id: number;
    user_id: number;
    stars: number;
  }): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/star`, data);
  }

  /**
   * 💬 Get all comments by stock_id
   */
  getCommentsByStock(stockId: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/${stockId}/comments`);
  }

  /**
   * ➕ Add comment
   */
  addComment(data: {
    stock_id: number;
    user_id: number;
    comment: string;
  }): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/comment`, data);
  }
}
